import React, { useEffect, useRef, useState } from 'react';

// Поле времени «чч:мм»: печатается руками (1350 → 13:50, 9 → 09:00), по стрелке —
// список подсказок (сетка слота). Пустое значение = ограничения нет.
// Внешний вид — от .nv-select (styles.css), чтобы не отличаться от остальной карточки.

export function normalizeTime(raw) {
  const s = String(raw || '').trim().replace(/[.,\s-]+/g, ':');
  if (!s) return '';
  let h;
  let m;
  const hm = s.match(/^(\d{1,2}):?(\d{2})$/);
  if (hm) {
    h = parseInt(hm[1], 10);
    m = parseInt(hm[2], 10);
  } else if (/^\d{1,2}$/.test(s)) {
    h = parseInt(s, 10);
    m = 0;
  } else {
    return null;
  }
  if (h > 23 || m > 59) return null;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

// invalid — внешняя ошибка (например, время вне слота): рамка красная, пока родитель её держит.
// disabled — только показать (серое, без списка и ввода): окно заказа Flowwow.
export default function TimeCombo({ value, onChange, options = [], emptyLabel = '—', style = {}, invalid: invalidProp = false, disabled = false }) {
  const [text, setText] = useState(value || '');
  const [open, setOpen] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => { setText(value || ''); setInvalid(false); }, [value]);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const commit = () => {
    const n = normalizeTime(text);
    if (n === null) { setInvalid(true); return; }
    setInvalid(false);
    setText(n);
    if (n !== (value || '')) onChange(n);
  };

  const pick = (v) => {
    setInvalid(false);
    onChange(v);
    setOpen(false);
  };

  return (
    <div ref={wrapRef} className={`nv-select nv-time${invalid || invalidProp ? ' invalid' : ''}${disabled ? ' disabled' : ''}`} style={style}>
      <div className={`nv-select-trigger nv-time-trigger${open ? ' open' : ''}`}>
        <input
          className="nv-time-input"
          value={text}
          placeholder={emptyLabel}
          inputMode="numeric"
          disabled={disabled}
          title={disabled ? undefined : (invalid ? 'Время вводится как 13:50 (можно 1350)' : 'Введите время или выберите из списка')}
          onChange={(e) => { setText(e.target.value); setInvalid(false); }}
          onFocus={(e) => e.target.select()}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); commit(); setOpen(false); }
            else if (e.key === 'Escape') { e.preventDefault(); setOpen(false); }
            else if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(true); }
          }}
        />
        <button type="button" className="nv-time-chevron" tabIndex={-1} title={disabled ? undefined : 'Варианты'} disabled={disabled} onClick={() => setOpen(o => !o)}>
          <svg className="nv-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
      {open && !disabled && (
        <div className="nv-select-menu" role="listbox">
          <button type="button" role="option" aria-selected={!value} className={`nv-select-option${!value ? ' selected' : ''}`} onClick={() => pick('')}>
            <span>{emptyLabel}</span>
          </button>
          {options.map((v) => (
            <button key={v} type="button" role="option" aria-selected={v === value} className={`nv-select-option${v === value ? ' selected' : ''}`} onClick={() => pick(v)}>
              <span>{v}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
